import { ICalltracking as ICalltrackingSchema } from '../../../../repositories/billing-tariffs/entities/PublishTerms/Calltracking';
import { ICalltrackingState } from '../../../../types/reducers/calltracking';
import { EServiceType } from '../../../../types/reducers/publishTerms';
import { mapPeriod } from '../mapPeriod';
import { isCalltrackingEnabled } from './isCalltrackingEnabled';

export const mapCalltracking = (calltrackingTerm?: ICalltrackingSchema | null): ICalltrackingState => {
  const {
    isAvailable = false,
    isCompulsory = false,
    incompatibleServices,
    period: rawPeriod,
    calltrackingPhoneSubstitutionsCount = null,
  } = calltrackingTerm || {};

  const period = rawPeriod ? mapPeriod(rawPeriod) : null;

  const isPaid = !!rawPeriod?.isPaid;
  const isEnabled = isCalltrackingEnabled({ isAvailable, isCompulsory, isPaid });

  return {
    isAvailable,
    isEnabled,
    incompatibleServices: (incompatibleServices as Array<string> as Array<EServiceType>) || [],
    isCompulsory,
    calltrackingPhoneSubstitutionsCount,
    period,
  };
};
